import { useEditorStore } from '../../store/editorStore';
import { ContextMenu } from '../context/ContextMenu';
import { Diagnostics } from '../preview/Diagnostics';
import { PreviewPanel } from '../preview/PreviewPanel';
import { Inspector } from '../panels/Inspector';
import { Timeline } from '../timeline/Timeline';
import { MobileToolBar } from '../timeline/MobileToolBar';
import { PanelResizer } from '../ui/PanelResizer';
import { LeftDock } from './LeftDock';
import { TopBar } from './TopBar';
import { WorkspaceRail } from './WorkspaceRail';

export function EditorShell() {
  const leftWidth = useEditorStore((state) => state.leftPanelWidth);
  const inspectorWidth = useEditorStore((state) => state.inspectorWidth);
  const timelineHeight = useEditorStore((state) => state.timelineHeight);
  const setSize = useEditorStore((state) => state.setPanelSize);
  return <div className="studio-shell" style={{ '--left-width': `${leftWidth}px`, '--inspector-width': `${inspectorWidth}px`, '--timeline-height': `${timelineHeight}px` } as React.CSSProperties}>
    <TopBar />
    <div className="studio-main">
      <WorkspaceRail />
      <LeftDock />
      <PanelResizer axis="x" className="left-resizer" onResize={(delta) => setSize('left', leftWidth + delta)} />
      <main className="center-workspace"><PreviewPanel /><PanelResizer axis="y" className="timeline-resizer" onResize={(delta) => setSize('timeline', timelineHeight - delta)} /><Timeline /></main>
      <PanelResizer axis="x" className="inspector-resizer" onResize={(delta) => setSize('inspector', inspectorWidth - delta)} />
      <Inspector />
    </div>
    <MobileToolBar />
    <Diagnostics />
    <ContextMenu />
  </div>;
}
